export default __webpack_public_path__ + "static/media/privatekey.fafbac93.svg";